module.exports = __webpack_public_path__ + "media/images/gestor_notarial_bg-a2787282.png";